import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import StatusPill from "./StatusPill";
import { formatTimeUntil } from "../../utils/countdownFormat";
import "./countdownChip.css";

/** Live countdown in a status chip. Ticks every second so it reads as "alive". */
export default function CountdownChip({
  targetAt,
  variant = "neutral",
  pulse = false,
  className = "",
}) {
  const [nowMs, setNowMs] = useState(Date.now);

  useEffect(() => {
    if (!targetAt) return undefined;
    const id = setInterval(() => setNowMs(Date.now()), 1000);
    return () => clearInterval(id);
  }, [targetAt]);

  if (!targetAt) return null;

  return (
    <StatusPill
      variant={variant}
      size="sm"
      className={["countdown-chip__pill", className].filter(Boolean).join(" ")}
    >
      {pulse && <span className="countdown-chip__dot" aria-hidden="true" />}
      {formatTimeUntil(targetAt, nowMs)}
    </StatusPill>
  );
}

CountdownChip.propTypes = {
  targetAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  variant: PropTypes.string,
  pulse: PropTypes.bool,
  className: PropTypes.string,
};
